import { useContext } from 'react';
import { Heading, SubHeading, Glyphicon, Text } from 'reaxl';
import { useFeatures } from '@atc/features';
import WalletSyncBanner from '../../WalletSyncBanner/WalletSyncBanner.js';
import ConfigContext from '../../ConfigContext/ConfigContext.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function UDSTitleContainer(_ref) {
  let {
    paymentsDuck = {},
    updateMyWallet = () => {}
  } = _ref;
  const {
    showWalletSyncBanner = false
  } = useContext(ConfigContext) ?? {};
  const {
    nds_calc: [, {
      kbb_text_trade_mark: enableKbbTextTradeMark
    }] = []
  } = useFeatures(['nds_calc']);
  const renderKbbTextTradeMark = () => {
    if (!enableKbbTextTradeMark) {
      return null;
    }
    const subHeading = /*#__PURE__*/jsxs(SubHeading, {
      weight: "normal",
      level: 4,
      children: [/*#__PURE__*/jsx(Glyphicon, {
        className: "text-size-300 padding-right-1",
        glyph: "wallet"
      }), "My Wallet", /*#__PURE__*/jsx(Text, {
        weight: "normal",
        children: " by Kelley Blue Book"
      }), /*#__PURE__*/jsx("span", {
        className: "text-valign-super text-size-100",
        children: "\xAE"
      })]
    });
    if (!showWalletSyncBanner) {
      return subHeading;
    }
    return /*#__PURE__*/jsxs("div", {
      className: "display-flex flex-column flex-sm-row gap-2 justify-content-between align-items-baseline",
      children: [subHeading, /*#__PURE__*/jsx(WalletSyncBanner, {
        paymentsDuck: paymentsDuck,
        updateMyWallet: updateMyWallet
      })]
    });
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Heading, {
      level: 3,
      color: "primary",
      children: "Build Your Offer"
    }), renderKbbTextTradeMark()]
  });
}
export { UDSTitleContainer as default };
